import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";

export async function razorPayment(body) {
    return fetch(
    Config.apiUrl + 
      "usersubscription/createSubscription",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      }
    )
      .then(handleResponse)
      .catch(handleError);
  }